module.exports = __webpack_public_path__ + "img/form.46466286.svg";